<template>
  <NuxtLayout name="standard">
    <TContainer class="w-full pb-16 lg:pb-0">
      <div class="grid grid-cols-12 gap-x-4">
        <div
          class="col-span-12 row-start-2 lg:col-span-6 lg:row-start-auto flex flex-wrap content-center"
        >
          <div class="">
            <TText
              size="lg"
              tag="h2"
              variant="semibold"
              color="text-primary-600"
              classes="mb-4"
            >
              {{ t('error.page.subtitle', { code: error?.statusCode }) }}
            </TText>
            <TTitle :tag="'h1'" size="4xl">{{ t('error.page.title') }}</TTitle>
            <ULink href="/" :active="true" :external="true">{{
              t('error.page.backHome')
            }}</ULink>
          </div>
        </div>
        <div class="col-span-12 row-start-1 lg:col-span-6 lg:row-start-auto">
          <img
            src="~/assets/img/pagina-error.jpg"
            class="w-full"
            alt="pagina-error"
          />
        </div>
      </div>
    </TContainer>
  </NuxtLayout>
</template>

<script setup lang="ts">
import type { NuxtError } from '#app'
import { datadogLogs } from '@datadog/browser-logs'

const props = defineProps({
  error: Object as () => NuxtError,
})

if (props.error && import.meta.server) {
  const { useWinston } = await import('~/composables/useWinston')
  const winston = useWinston()
  const route = useRoute()

  const currentUrl = route.fullPath as string | undefined
  const pagename = route.name as string | undefined

  const errorLog = {
    status: 'error',
    statusCode: props.error.statusCode,
    message: `NuxtErrorPage: Server-side error: ${props.error.message}`,
    fatal: props.error.fatal,
    unhandled: props.error.unhandled,
    data: props.error.data,
    cause: props.error.cause,
    url: currentUrl,
    pagename,
    stack: props.error.stack,
  }

  winston.error(errorLog)
}

onMounted(() => {
  if (props.error && import.meta.client) {
    const route = useRoute()
    const pagename = route.name as string | undefined

    const errorContext = {
      status: 'error',
      statusCode: props.error.statusCode,
      fatal: props.error.fatal ?? false,
      unhandled: props.error.unhandled ?? false,
      data: props.error.data,
      url: window.location.href,
      pagename,
    }

    datadogLogs.logger.error(
      'NuxtErrorPage: Client-side error',
      errorContext,
      props.error,
    )
  }

  if (props.error?.statusCode === 404) {
    const script = document.createElement('script')
    script.src = '//static.getclicky.com/js'
    script.async = true
    script.setAttribute('data-id', '101489167')
    document.body.appendChild(script)
  }
})
</script>
